import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html {
    margin: 0;
    padding: 0;
    /* Dark navy — shown on the sides of the app container on wide screens */
    background-color: #00111a;
  }

  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    background-color: #00111a;
    font-family: 'Roboto', sans-serif;
    color: ${({ theme }) => theme.colors.textPrimary};
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  /* The app must always paint the full viewport — no white canvas can ever
     show through on wide screens. */
  #root {
    min-height: 100vh;
    background-color: #00111a;
  }

  h1, h2, h3, h4 {
    color: ${({ theme }) => theme.colors.textPrimary};
    margin: 0;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 20px;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  button {
    background-color: ${({ theme }) => theme.colors.primary};
    color: #fff;
    border: none;
    padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  /* Lower z-index of Leaflet controls so NavBar menu drawer appears on top */
  .leaflet-top .leaflet-control {
    z-index: 500 !important;
  }
`;
